export const resolveUrl = (url: string | null): string | null => {
  if (url === null || typeof url === 'undefined') {
    return null
  }
  const a = document.createElement('a')
  a.href = url
  return a.href
}

export const resolveUrls = <T extends { [key: string]: string }>(urls: T | null): T | null => {
  if (!urls) {
    return null
  }
  const result = { ...urls }
  for (const key in result) {
    result[key as keyof T] = resolveUrl(result[key as keyof T]) as T[keyof T]
  }
  return result
}
